<div class="box">
  <div class="header">
    <div class="content" [ngClass]="'greendAnalityco' || 'primary'">{{'CONFIGURACION' || 'N/A'}}</div>
  </div>
    <div class="content-card list-card">
      <form [formGroup]="configForm">
        <div class="columns-header">
          <div class="col-number"></div>
          <div class="col-label"><strong>Cantidad</strong></div>
          <div class="col-label"><strong>Unidad</strong></div>
        </div>

        <div formArrayName="items">
          <div class="form-row" *ngFor="let group of items.controls; let i = index" [formGroupName]="i">
            <div class="item-number">{{ i + 1 }}.</div>

            <mat-form-field appearance="outline" class="quantity-field mat-compact" floatLabel="never">
              <input matInput type="number" formControlName="quantity" min="1"
                (keydown)="preventInvalid($event)" class="no-spinner"/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="unit-field mat-compact" floatLabel="never">
              <mat-select formControlName="unit"  style="text-align: end !important; font-weight: bold;">
                <mat-option *ngFor="let unit of units" [value]="unit.value">{{ unit.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <button *ngIf="i === 0" mat-icon-button class="clear-icon-red " aria-label="Eliminar"
                    (click)="clearFirstRow()"><mat-icon>close</mat-icon>
            </button>

            <button *ngIf="i > 0" mat-icon-button color="warn" class="delete-button" aria-label="Eliminar"
              (click)="removeRow(i)"><mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div class="explanation-text">
          Este tiempo se sumará a la fecha de inicio para calcular la fecha de vencimiento
        </div>

        <button type="button" mat-raised-button color="primary" class="add-button"
          (click)="addRow()">+ AGREGAR
        </button>
      </form>
    </div>

    <div class="btn-actions">
    <button mat-button class="btn-cancelar" (click)="close()">CANCELAR</button>&nbsp;&nbsp;
    <button mat-button class="btn-generar" (click)="save()" [disabled]="configForm.invalid">GUARDAR</button>
  </div>
</div>
